import { render, staticRenderFns } from "./SubModuloPage.vue?vue&type=template&id=617d3a88"
import script from "./SubModuloPage.vue?vue&type=script&lang=js"
export * from "./SubModuloPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports